import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import ColorField from './ColorField';
import { ColorFieldsStyled } from './ColorSettings.styles';

const ColorSettingsModalContent = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>
          {t('pageDirectBookingEngine.colorSettings.title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ColorFieldsStyled>
          <ColorField
            label={t('pageDirectBookingEngine.colorSettings.headlineColor')}
            name="headlineColor"
          />
          <ColorField
            label={t('pageDirectBookingEngine.colorSettings.primaryColor')}
            name="primaryColor"
          />
          <ColorField
            label={t('pageDirectBookingEngine.colorSettings.secondaryColor')}
            name="secondaryColor"
          />
        </ColorFieldsStyled>
      </Modal.Body>
      <Modal.Footer>
        <ModalFormCancelButton
          closeOnClick={false}
          data-testid="cancel-color-settings-button"
          onClick={onClose}
        />
        <ModalFormSubmitButton data-testid="save-color-settings-button">
          {t('pageDirectBookingEngine.colorSettings.save')}
        </ModalFormSubmitButton>
      </Modal.Footer>
    </>
  );
};

export default ColorSettingsModalContent;
